<template>
  <div class="d-ib">
    <el-button
      type="primary"
      class="btn-main"
      icon="el-icon-search"
      @click="setDialog(true)"
    >
      Filters
    </el-button>
    <el-dialog
      title="Filters"
      :visible="dialog"
      width="500px"
      top="3vh"
      :modal="true"
      @close="setDialog(false)"
    >
      <el-select
        v-model="label"
        placeholder="Label"
        clearable
        filterable
        class="w100"
      >
        <el-option
          v-for="(r, i) in labels"
          :key="i"
          :label="r.label"
          :value="r.label"
        ></el-option>
      </el-select>
      <el-select
        v-model="license"
        placeholder="License"
        clearable
        filterable
        class="mt10 w100"
      >
        <el-option value="Yes" label="Yes"></el-option>
        <el-option value="No" label="No"></el-option>
        <el-option value="Check Manually" label="Check Manually"></el-option>
      </el-select>
      <el-select
        v-model="status"
        placeholder="Status"
        clearable
        filterable
        class="mt10 w100"
      >
        <el-option value="Potential" label="Potential"></el-option>
        <el-option value="Disputed" label="Disputed"></el-option>
        <el-option value="Appealed" label="Appealed"></el-option>
      </el-select>
      <div slot="footer">
        <el-button type="danger" size="mini" @click="clear()">
          Clear
        </el-button>
        <el-button type="primary" size="mini" @click="filter()">
          Filter
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'

export default {
  data() {
    return {
      label: '',
      license: '',
      status: ''
    }
  },
  computed: {
    ...mapState('youtubeClaims', ['dialog', 'labels'])
  },
  methods: {
    ...mapMutations('youtubeClaims', ['setDialog', 'setFilter']),
    ...mapActions('youtubeClaims', ['readClaims']),

    filter() {
      this.setFilter({
        label: this.label,
        license: this.license,
        status: this.status
      })
      this.readClaims('Public')
      this.readClaims('Private')
      this.setDialog(false)
    },

    clear() {
      this.setFilter({})
      this.readClaims()
      this.label = ''
      this.license = ''
      this.status = ''
      this.setDialog(false)
    }
  }
}
</script>
